// See: https://github.com/albert-io/nexus/issues/8428
// Essentially, we want to change "Middle School" and "High School" to "Grades 5-8" and "Grades 9-12" respectively.
// Additionally, we want the urls to stay the same. It's much simpler to keep subjectMenuData the same and override the text
// in the UI since otherwise we need to deal with logic related to active routes and such.
export default function getOverriddenDomainString(domain: string): string | undefined {
  const domainTextOverrides = {
    'High School': 'Grades 9-12',
    'Middle School': 'Grades 5-8'
  };

  return domainTextOverrides[domain];
}
